{
	"orderQtyInput": {
		"qty": "Quantity",
		"available": "available",
		"shareOfPortfolio": "Portfolio Share, %",
		"amount": "Amount, in USD",
		"pcs": "pcs."
	}
}
